import { Suspense, useEffect } from 'react'
import { Navigate, BrowserRouter, Route, Routes } from 'react-router-dom'

import { useSelector } from 'react-redux'

import { PrivateRoutes, PublicRoutes } from 'routes'
import { PrivateLayout, PublicLayout } from 'layouts'
import { Loading } from 'components'

import { routes } from 'utils/routes'
import Error404 from 'pages/404'
import { _object } from 'utils/interfaces'
import 'react-phone-number-input/style.css'

const App = () => {
  const { isUserLoggedIn } = useSelector((state: _object) => state?.session)

  useEffect(() => {
    document.body.removeAttribute('class')
    document.body.className = window.location.pathname.split('/').join(' ').trim()
  })

  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route
            path="/app"
            element={isUserLoggedIn ? <PrivateLayout /> : <Navigate to={`${routes.login}`} />}
          >
            {/* <Route index element={<Navigate to={`${routes.dashboard}`} />} /> */}

            {PrivateRoutes.map((route, i) => {
              return (
                route.component && <Route key={i} path={route.path} element={<route.component />} />
              )
            })}
          </Route>

          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Navigate to={`${routes.login}`} />} />
            {PublicRoutes.map((route, i) => {
              return (
                route.component && <Route key={i} path={route.path} element={<route.component />} />
              )
            })}
          </Route>
          <Route path="*" element={<Error404 />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App
